export enum AlertContainerType {
  // eslint-disable-next-line no-unused-vars
  WARNING = 'warning',
  // eslint-disable-next-line no-unused-vars
  ERROR = 'error',
  // eslint-disable-next-line no-unused-vars
  ACTION = 'action',
  // eslint-disable-next-line no-unused-vars
  INFO = 'info',
}
